export const formatCurrency = (value: number, currency: string = "USD"): string =>
	value.toLocaleString("en-US", {
		currency,
		style: "currency"
	});
